import { Card } from '@/components/card';
import { Page } from '@/components/page';

import styles from './tenders.module.css';

export const Tenders: React.FC = () => {
  return (
    <Page>
      <Page.SideBar>
        <Page.SideBar.Header title="Tender Search" />
      </Page.SideBar>
      <Page.Main>
        {/*TODO: move it to the TenderControls when it will be created*/}
        <Card className={styles.results}>
          <Card.Header title="Tender Results" />
        </Card>
      </Page.Main>
    </Page>
  );
};
